import { Stack, Typography } from "@mui/material";
import { Button } from "~/components/ui/core/Button";
import { Modal, type ModalAction } from "~/components/ui/core/Modal";
import { useI18n } from "~/lib/i18n/useI18n";
import { useDeleteFiltersPresetMutation } from "~/pages/api/filters-preset/delete-filters-preset";
import { useFetchFiltersPresetsQuery } from "~/pages/api/filters-preset/fetch-filters-presets";

type ModalProps = Pick<React.ComponentProps<typeof Modal>, "isOpen" | "onClose">;

export const DeletePresetModal: React.FC<ModalProps> = ({ isOpen, onClose }) => {
  const { t } = useI18n();

  const { data: filtersPresets } = useFetchFiltersPresetsQuery();
  const deleteUserFilterPresetMutation = useDeleteFiltersPresetMutation({
    successMessage: t("components.market-data-filters.delete-presets-modal.success-message"),
  });

  const secondaryAction = {
    label: t("components.market-data-filters.delete-presets-modal.secondary-action"),
    onClick: () => {
      onClose();
    },
  } satisfies ModalAction;

  return (
    <Modal
      secondaryAction={secondaryAction}
      isOpen={isOpen}
      title={t("components.market-data-filters.delete-presets-modal.modal-title")}
      onClose={onClose}
      showCloseButton
      className="w-[800px]"
    >
      <Stack spacing={4} justifyContent="center" width="100%">
        {filtersPresets?.map((preset) => (
          <Stack
            key={preset.id}
            className="space-x-6 rounded-md border border-gray-200 p-4"
            alignItems="center"
            justifyContent="space-between"
            direction="row"
          >
            <Typography variant="h2">{preset.name}</Typography>
            <Button
              variant="outlined"
              color="secondary"
              onClick={async () => {
                await deleteUserFilterPresetMutation.mutateAsync({ presetId: preset.id });
              }}
              disabled={deleteUserFilterPresetMutation.isLoading}
            >
              Delete
            </Button>
          </Stack>
        ))}
      </Stack>
    </Modal>
  );
};
